<div class="container">
    <div class="section-title">
        <!-- <span class="sub-title">Course Advisor</span> -->
        <h2>Meet Our Founder / Director</h2>
        <p>Our Founder / Director are experienced professionals dedicated to your success, bringing real-world knowledge and
            passion to every lesson.</p>
    </div>
    <div class="advisor-slides-two">
        <owl-carousel-o [options]="advisorSlidesTwo">
            <ng-template carouselSlide>
                <div class="single-advisor-item">
                    <div class="advisor-image">
                        <img src="images/divya.jpg" alt="image">
                    </div>
                    <div class="advisor-content">
                        <h3><a>DR. DIVYA TRAPASIYA</a></h3>
                        <span>FOUNDER / DIRECTOR</span>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-advisor-item">
                    <div class="advisor-image">
                        <img src="images/hiren.jpg" alt="image">
                    </div>
                    <div class="advisor-content">
                        <h3><a>HIREN TARAPARA</a></h3>
                        <span>FOUNDER / DIRECTOR</span>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-advisor-item">
                    <div class="advisor-image">
                        <img src="images/vijay.jpg" alt="image">
                    </div>
                    <div class="advisor-content">
                        <h3><a>DR. VIJAY TRAPASIYA</a></h3>
                        <span>FOUNDER / DIRECTOR</span>
                    </div>
                </div>
            </ng-template>
            <!-- <ng-template carouselSlide>
                <div class="single-advisor-item">
                    <div class="advisor-image">
                        <img src="images/shraddha_chauhan.png" alt="image">
                    </div>
                    <div class="advisor-content">
                        <h3><a>SHRADDHA CHAUHAN</a></h3>
                        <h5>(PROFFESOR)</h5>
                        <span>(B.Sc Micro + PGDMLT)</span>
                    </div>
                </div>
            </ng-template> -->
        </owl-carousel-o>
    </div>
</div>